import VueRouter from 'vue-router'
import Store from './stores'
import Error from './pages/error'
import Install from './pages/install/install'
import InstallPayment from './pages/install/install-payment'
import InstallPaymentConfirm from './pages/install/install-payment-confirm'
import InstallPaymentDecline from './pages/install/install-payment-decline'
import Home from './pages/page-home'
import DummyRouterView from './pages/dummy-router-view'
import { logger } from './helpers/logger'
import { isShopifyEmbedded, isShopifyContext } from './helpers/is-shopify-embedded'
import { isValidShopDomain, buildAdminAppUrl } from './helpers/admin-url'

import PageEdit from './pages/page-edit'
import PageManage from './pages/page-manage'
import PageManageCustomObjects from './pages/page-manage-customobjects'
import PageManageIntegrations from './pages/page-manage-integrations'
import PageSelect from './pages/page-select'
import { MDSModalConfirmDecisionModel } from '@/models/modal-datasets.model'
import { checkLocalStorage } from './helpers/check-storage'

const routes = [
    {
        name: 'error',
        path: '*',
        component: Error
    },
    {
        name: 'install',
        path: '/install',
        component: Install,
        children: [
            {
                name: 'install.payment',
                path: 'payment',
                component: InstallPayment
            },
            {
                name: 'install.payment.confirm',
                path: 'payment/confirm',
                component: InstallPaymentConfirm
            },
            {
                name: 'install.payment.decline',
                path: 'payment/decline',
                component: InstallPaymentDecline,
                meta: { no_spinner: true }
            }
        ]
    },
    {
        name: 'home',
        path: '/',
        component: Home,
        meta: {
            title: 'Dashboard',
            buttonsSet: 'dashboard',
            store: 'shopCustomobjectsgroupsList',
            scope: 'customobjects'
        }
    },
    {
        name: 'select',
        path: '/select-resource',
        component: PageSelect,
        meta: {
            title: 'Select Resource'
        }
    },
    {
        name: 'customobjectsgroups',
        path: '/customobjectsgroups',
        component: DummyRouterView,
        children: [
            {
                name: 'customobjectsgroups.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Custom objects groups Manage',
                    store: 'shopCustomobjectsgroupsManage',
                    scope: 'customobjectsgroups'
                }
            }
        ]
    },
    {
        name: 'customobjects',
        path: '/customobjects',
        component: DummyRouterView,
        children: [
            {
                name: 'customobjects.manage',
                path: 'manage',
                component: PageManageCustomObjects,
                meta: {
                    title: 'Custom objects Manage',
                    store: 'shopCustomobjectsgroupsManage',
                    scope: 'customobjectsgroups'
                }
            },
            {
                name: 'customobjects.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Custom objects',
                    store: 'shopCustomobjectsEdit',
                    scope: 'customobjects'
                }
            }
        ]
    },
    {
        name: 'articles',
        path: '/articles',
        component: DummyRouterView,
        children: [
            {
                name: 'articles.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Articles Manage',
                    store: 'shopArticlesManage',
                    scope: 'articles'
                }
            },
            {
                name: 'articles.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Articles Manage',
                    store: 'shopArticlesEdit',
                    scope: 'articles'
                }
            }
        ]
    },
    {
        name: 'blogs',
        path: '/blogs',
        component: DummyRouterView,
        children: [
            {
                name: 'blogs.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Blogs Manage',
                    store: 'shopBlogsManage',
                    scope: 'blogs'
                }
            },
            {
                name: 'blogs.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Blogs Edit',
                    store: 'shopBlogsEdit',
                    scope: 'blogs'
                }
            }
        ]
    },
    {
        name: 'collections',
        path: '/collections',
        component: DummyRouterView,
        children: [
            {
                name: 'collections.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Collections Manage',
                    store: 'shopCollectionsManage',
                    scope: 'collections'
                }
            },
            {
                name: 'collections.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Collections Edit',
                    store: 'shopCollectionsEdit',
                    scope: 'collections'
                }
            }
        ]
    },
    {
        name: 'customers',
        path: '/customers',
        component: DummyRouterView,
        children: [
            {
                name: 'customers.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Customers Manage',
                    store: 'shopCustomersManage',
                    scope: 'customers'
                }
            },
            {
                name: 'customers.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Customers Edit',
                    store: 'shopCustomersEdit',
                    scope: 'customers'
                }
            }
        ]
    },
    {
        name: 'globals',
        path: '/globals',
        component: DummyRouterView,
        children: [
            {
                name: 'globals.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Globals Manage',
                    store: 'shopGlobalsManage',
                    scope: 'shop'
                }
            },
            {
                name: 'globals.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Globals Edit',
                    store: 'shopGlobalsEdit',
                    scope: 'shop'
                }
            }
        ]
    },
    {
        name: 'orders',
        path: '/orders',
        component: DummyRouterView,
        children: [
            {
                name: 'orders.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Orders Manage',
                    store: 'shopOrdersManage',
                    scope: 'orders'
                }
            },
            {
                name: 'orders.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Orders Edit',
                    store: 'shopOrdersEdit',
                    scope: 'orders'
                }
            }
        ]
    },
    {
        name: 'pages',
        path: '/pages',
        component: DummyRouterView,
        children: [
            {
                name: 'pages.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Pages Manage',
                    store: 'shopPagesManage',
                    scope: 'pages'
                }
            },
            {
                name: 'pages.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Pages Edit',
                    store: 'shopPagesEdit',
                    scope: 'pages'
                }
            }
        ]
    },
    {
        name: 'products',
        path: '/products',
        component: DummyRouterView,
        children: [
            {
                name: 'products.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Products Manage',
                    store: 'shopProductsManage',
                    scope: 'products'
                }
            },
            {
                name: 'products.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Products Edit',
                    store: 'shopProductsEdit',
                    scope: 'products',
                    integrations: true
                }
            }
        ]
    },
    {
        name: 'variants',
        path: '/variants',
        component: DummyRouterView,
        children: [
            {
                name: 'variants.manage',
                path: 'manage',
                component: PageManage,
                meta: {
                    title: 'Variants Manage',
                    store: 'shopVariantsManage',
                    scope: 'variants'
                }
            },
            {
                name: 'variants.edit',
                path: 'edit',
                component: PageEdit,
                meta: {
                    title: 'Variants Edit',
                    store: 'shopVariantsEdit',
                    scope: 'variants'
                }
            }
        ]
    },
    {
        name: 'integrations',
        path: '/integrations',
        component: DummyRouterView,
        children: [
            {
                name: 'integrations.manage',
                path: 'manage',
                component: PageManageIntegrations,
                meta: {
                    title: 'Integrations Manage',
                    store: 'settingsIntegrations'
                }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

const isAppCharged = async () => {
    let charge = Store.getters['shop/charge']

    console.log('💳 Checking App Charge Status:', {
        hasCachedCharge: !!charge,
        cachedChargeStatus: charge
    })

    if (!charge) {
        console.log('🔄 Fetching charge from API...')
        try {
            charge = await Store.dispatch('shop/GET_SHOP_CHARGE')
            console.log('✅ Charge retrieved from API:', { status: charge })
        } catch (error) {
            console.log('❌ Failed to get charge:', error)
            return null
        }
    }

    const isActive = charge ? charge.status === 'active' : false
    console.log('💰 Final Charge Check:', {
        chargeStatus: charge,
        isActive,
        chargeObject: charge
    })

    return isActive
}

const isShopDev = async () => {
    let plan = Store.getters['shop/plan']

    console.log('🧪 Checking Dev Plan Status:', {
        hasCachedPlan: !!plan,
        cachedPlan: plan
    })

    if (!plan) {
        console.log('🔄 Fetching plan from API...')
        try {
            plan = await Store.dispatch('shop/GET_SHOP_PLAN')
            console.log('✅ Plan retrieved from API:', { plan })
        } catch (error) {
            console.error('❌ PLAN ERROR', error)
            return null
        }
    }

    const isDev = plan && (plan === 'trial' || plan === 'affiliate' || plan === 'partner_test')
    console.log('🔬 Final Dev Plan Check:', {
        plan,
        isDev,
        devPlans: ['trial', 'affiliate', 'partner_test']
    })

    return isDev
}

const initShopifyBar = () => {
    // Simplified - App Bridge now initializes automatically via script tag
    if (!Store.getters['shopifyBar/init']) {
        logger('init shopify bar')

        Store.dispatch('shopifyBar/INIT')
    }
}

const chargeApp = async ({ to, from, next }) => {
    if (
        to.name === 'install.payment.confirm' ||
        to.name === 'install.payment' ||
        to.name === 'install.payment.decline'
    ) {
        return next()
    }
    let charge = Store.getters['shop/charge']

    logger('charge')

    if (charge && charge.status !== 'accepted' && charge.status !== 'cancelled') {
        return next({ name: 'install.payment.decline' })
    }

    return next({ name: 'install.payment' })
}

const initInstalledApp = async ({ to, from, next }) => {
    console.log('🏁 INIT INSTALLED APP')

    // --> Update title (using new web component approach)
    const shopifyBarReady = Store.getters['shopifyBar/ready']
    console.log('📊 Updating Shopify bar:', {
        shopifyBarReady,
        title: to.meta.title,
        buttonsSet: to.meta.buttonsSet || 'item'
    })

    if (shopifyBarReady) {
        Store.commit('shopifyBar/UPDATE_PAGE_CONFIG', {
            title: to.meta.title,
            buttonsSet: to.meta.buttonsSet || 'item',
            visible: true
        })
    }

    console.log('✅ Init installed app complete - proceeding to route')
    return next()
}

const openCdnInformationModal = () => {
    const url = 'https://www.airfields.io/article/airfields-cdn-theme'
    const props = new MDSModalConfirmDecisionModel({
        title: 'Information',
        description: `Reminder: Airfields creates a new theme named "Airfields-Cdn-Theme" in your Shopify Online Store.<br>This theme is used to store uploaded images and should not be removed or renamed.<br>If you remove or rename this theme you will lose all your uploaded assets. You can find more details in the <a href="${url}" target="_blank" rel="noopener noreferrer">documentation.</a>`,
        btnTextConfirm: 'I understand and want to proceed',
        btnTextCancel: '',
        closeOnlyByConfirmButton: true,
        confirmationHandler: () => {
            if (checkLocalStorage()) {
                window.localStorage.setItem('cdn-popup-accepted', 'true')
            }
        }
    })
    const name = 'ModalConfirmDecision'

    Store.commit('modals/OPEN_MODAL', { name, props })
}

router.beforeEach(async (to, from, next) => {
    logger('route', to.path)

    // Hide Shopify title bar on install/error pages
    if (to.name && (to.name.startsWith('install') || to.name === 'error')) {
        Store.commit('shopifyBar/SET_VISIBLE', { visible: false })
    }

    if (to.name === 'error') {
        return next()
    }

    // --> Opened outside the Shopify admin: go through the admin, never run OAuth here.
    // Shopify Mobile uses a top-level WebView (no iframe), so also check the Shopify context.
    if (!Store.getters['shop/domain'] && !isShopifyEmbedded() && !isShopifyContext(to.query)) {
        const shop = to.query.shop

        if (isValidShopDomain(shop)) {
            window.location.assign(
                buildAdminAppUrl({
                    shop,
                    apiKey: process.env.SHOPIFY_API_KEY,
                    path: to.path,
                    query: to.query
                })
            )
            return next(false)
        }

        return next({ name: 'error', query: { reason: 'open-from-admin' } })
    }

    initShopifyBar()

    // --> Establish the session from the App Bridge ID token
    if (!Store.getters['shop/domain']) {
        try {
            await Store.dispatch('shop/START_SESSION')
        } catch (error) {
            return next({ name: 'error' })
        }
    }

    // --> Check charge
    let dev = await isShopDev()
    let isCharged = await isAppCharged()
    logger('process.env.FORCE_CHARGE:', process.env.FORCE_CHARGE)

    // 📊 DEBUG: App Status
    console.log('📊 App Status Check:', {
        isDev: dev,
        isCharged,
        forceCharge: process.env.FORCE_CHARGE
    })

    if ((!dev || (process.env.FORCE_CHARGE && 'false' !== process.env.FORCE_CHARGE)) && !isCharged) {
        console.log('💳 Redirecting to Charge App')
        return chargeApp({ to, from, next })
    }

    console.log('✅ Proceeding to Init Installed App')
    return initInstalledApp({ to, from, next })
})

let popupAccepted = false

router.afterEach(to => {
    window.scroll({
        top: 0,
        left: 0
    })

    if (to.name.indexOf('install') === -1 && to.name.indexOf('error') === -1) {
        if (!checkLocalStorage()) {
            if (!popupAccepted) {
                setTimeout(() => {
                    openCdnInformationModal()
                    popupAccepted = true
                }, 500)
            }
        } else if (!window.localStorage.getItem('cdn-popup-accepted')) {
            setTimeout(() => {
                openCdnInformationModal()
                popupAccepted = true
            }, 500)
        }
    }
})

export { router, routes }



// WEBPACK FOOTER //
// ./src/router.js